import { cn } from '@/lib/utils'

import { AdditionalInformationEoir } from '../../../ui/additional-information-eoir/additional-information-eoir'
import { BasicInformationEoir } from '../../../ui/basic-information-eoir/basic-information-eoir'
import { OtherCriticalDatesInternal } from './other-critical-dates-internal/other-critical-dates-internal'
import { useClientPortalEoirInternalContent } from './use-client-portal-eoir-internal-content'

export const ClientPortalEoirInternalContent = () => {
  const {
    caseData,
    companyData,
    currentStatusData,
    historyData,
    nextHearingData,
    courtData,
    scheduledAlertsData,
    showsOtherCriticalDates,
    navigateToEoirCaseDetail,
  } = useClientPortalEoirInternalContent()

  return (
    <div className={cn('pt-4 lg:pt-[30px]')}>
      <BasicInformationEoir
        caseData={caseData}
        companyData={companyData}
        currentStatus={currentStatusData}
        historyData={historyData}
      />
      <AdditionalInformationEoir nextHearingData={nextHearingData} courtData={courtData} />
      {showsOtherCriticalDates && (
        <OtherCriticalDatesInternal
          scheduledAlertsData={scheduledAlertsData}
          onClickGoToCaseDetailButton={navigateToEoirCaseDetail}
        />
      )}
    </div>
  )
}
